/**
 * Closes the closest modal containing the specified button by removing the 'show' class.
 * @param button - The button element that triggered the modal close action. If no specific button is provided, the function will look for the closest modal to close.
 * @param anyModal - A boolean flag that determines whether to close any modal that is currently open. If `anyModal` is set to `true`, the function will close the modal with the class `modal show` regardless of which button triggered the function.
 */
export function closeModal(button: HTMLElement | null = null, anyModal: boolean = false): void {
    // Find the closest modal that contains the button
    let modal: Element | null;

    if (button === null && anyModal) {
        modal = document.querySelector('.modal.show');
    } else if (button !== null && button.classList.contains('modal')) {
        modal = button;
    } else if (button !== null) {
        modal = button.closest('.modal.show');
    } else {
        modal = null;
    }

    // If the modal is found, remove the 'show' class
    if (modal) {
        window.modalID = undefined;
        modal.classList.remove('show');
        (modal as HTMLElement).style.display = 'none';

        // Check if modal-backdrop is still .show
        setTimeout(() => {
            if (document.querySelector('.modal-backdrop.show') !== null) {
                document.querySelector('.modal-backdrop.show').remove()
            }
        }, 500);
    }
}